import { useMemo } from "react";

import { Rate } from "../types";
import { isVolumeBasedRate } from "../utils/premium-calculations";

export function useIsVolumeBased(rates: Rate[]): boolean {
  return useMemo(() => isVolumeBasedRate(rates[0]), [rates]);
}
